import React, {useState ,useEffect} from 'react';
import {Link} from "react-router-dom";

import CategoryTechnologies from '../../components/categoryTechnologies.js'
import {AdvertisersPageResult} from '../../../../server/routes/advertisers.js'

export default function AdvertisersPage({server, pageData}: {server: string, pageData: unknown} ) {

    const typedPageData = pageData as AdvertisersPageResult;
    let [data, setData] = useState(typedPageData);

	return (
        <>
            <AdvertisersHeader props={data}/>
        </>
	)
}

function AdvertisersHeader({props}: {props: AdvertisersPageResult}) {
    
    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
        var q = document.getElementById('q') as HTMLInputElement;
        let t=String(q.value).trim();

//        document.location = '/search?hint=ads&q='+t;           
        document.location = '/search?q='+t;           
      }  
      
    return (
        <>      
          <section className="section section-sm text-center">
            <div className="container">
                <h3 className="text-right" style={{color:'darkblue'}}>
                    Accurate web technology detection
                </h3>
                <h4 className="text-right" style={{color:'darkblue'}}>
                    <b>
                        Discovered {' '}<b>{props.AdvertisersCount}</b>{' '}
                        advertisers on 120+ million top sites.
                    </b>
                </h4>
            </div>            
            <div className="container">               
                <div className="text-center">
                    <h2>Advertiser Lookup</h2>
                    <p>
                        <span style={{maxWidth: '690px'}}>
                        </span>
                    </p>
                </div>

                <br/>
                <br/>
                <div>			
                    <form className="rd-form rd-search form-inline" action="search" method="GET"   onSubmit={handleSubmit}>
                        <div className="form-wrap">
                            <input required type="text" className="form-input" title="Lookup ads.txt Advertiser by name" placeholder="Search ads.txt Advertiser by name (for example rubiconproject.com RESELLER)" name="q" id="q"/>
                        </div>  
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit" >Search</button>
                        </div>
                    </form>
                </div>            
            </div>
        </section>        
        <section className="section section-sm">
 
            <div className="container">
                <CategoryTechnologies categoryTechnologies={props.Advertisers}/>

            </div>
        </section>
        </>

    )
}
